import { resolvePageFormat, type PageFormat } from "./format";
import { useRenderMode } from "./renderMode";

/** What the hook reads off a page: its metadata (`PageMetadata.format`) or the bare format value. */
export type PageFormatSource = { format?: unknown } | string | null | undefined;

/**
 * The page's format with the full precedence of `resolvePageFormat` (dev `?format=` > render-mode switch > page metadata >
 * default), re-evaluated whenever the shell's switch changes, so the reader, history and editor re-render on a flip.
 */
export function useResolvedPageFormat(page?: PageFormatSource): PageFormat {
    const [mode] = useRenderMode();
    const metadata = typeof page === "string" ? page : page?.format;
    return resolvePageFormat({ metadata, mode });
}
